import { keyframes, styled } from "@pigment-css/react";

const fadeIn = keyframes({
  from: { opacity: 0, transform: "translateY(8px)" },
  to: { opacity: 1, transform: "translateY(0)" },
});

const TOAST_BORDER = "rgba(255,255,255,0.48)";
const TOAST_BLUR = "blur(3px)";

export const ToastCapsule = styled("div")(({ theme }) => ({
  pointerEvents: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.fieldSalesTwo.spacing[12],
  height: theme.fieldSalesTwo.spacing[48],
  flexShrink: 0,
  paddingInline: theme.fieldSalesTwo.spacing[20],
  borderRadius: theme.fieldSalesTwo.radius.circular,
  border: `${theme.strokeWidth.thin} solid ${TOAST_BORDER}`,
  background: theme.fieldSalesTwo.colors.surface.glassMedium,
  backdropFilter: TOAST_BLUR,
  WebkitBackdropFilter: TOAST_BLUR,
  boxShadow: theme.fieldSalesTwo.shadows.glass,
  animation: `${fadeIn} ${theme.fieldSalesTwo.motion.duration.base} ${theme.fieldSalesTwo.motion.easing.emphasized}`,
  // Pin height and let width follow the icon's aspect ratio — icons differ (12×11 vs 15×19),
  // so a fixed square would distort the non-square ones.
  "& svg": { height: theme.fieldSalesTwo.spacing[20], width: "auto" },
}));

export const ToastMessage = styled("span")<{ tone?: "success" | "destructive" }>(({ theme }) => ({
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[14],
  fontWeight: theme.fieldSalesTwo.font.weight[500],
  lineHeight: theme.fieldSalesTwo.font.lineHeight[168],
  color: theme.fieldSalesTwo.colors.neutral[900],
  whiteSpace: "nowrap",
  variants: [
    { props: { tone: "success" }, style: { color: theme.fieldSalesTwo.colors.status.success.main } },
    { props: { tone: "destructive" }, style: { color: theme.fieldSalesTwo.colors.status.error.main } },
  ],
}));
